import React from 'react';
import './mobileLandingBtmCrd.css'

function C2wMobileLandingBtmCrd( { obj, index } ) {
  return (
    <div className='C2wSuperxLandingBottom_ctn_content'>
    <div className='C2wSuperxLanding_span_hld'>
      <span className='mobileView_count'>{obj?.count}+</span>
      <span className='mobileView_heading'>{obj?.subHeading}</span>
    </div>
    { index < 3 && 
      <div className='C2wSuperxLanding_span_line'></div>
    }
</div>
  )
}

export default C2wMobileLandingBtmCrd
